<div *ngIf="finished==false" class='text-center'>
  <svg width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling"
    style="background: none;">
    <circle cx="50" cy="50" fill="none" stroke="#28a745" stroke-width="7" r="35"
      stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(346.659 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
        keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
    </circle>
  </svg>
</div>

<div *ngIf="profileData !== undefined">
  <div class="bg-white profile_content p-3 mb-3 text-center">
    <div class="profile_picture mb-3">
      <img class="profile_picture" src={{profileData.profile_pic}}  onerror="this.src='assets/img/image_placeholder.svg'">
      <div class="profile_pic_text">
        <span><img class="pr-2" src="assets/img/profileLock.webp">{{mls.languageText.profile.key1}}</span>
      </div>
    </div>
    <div class="user_name">{{profileData.registered_name}}</div>
  </div>

  <div class="profile_content w-100 bg-white p-3 mb-3">
    {{mls.languageText.profile.key2}}
    <div class="float-right profile_locked">
      <img class="pr-2" src="assets/img/locked.webp">{{mls.languageText.profile.key1}}
    </div>
  </div>

  <div class="profile_content w-100 bg-white p-3 mb-3">
    <img class="pr-2" src="assets/img/education.webp"> {{mls.languageText.profile.key3}}
    <div class="float-right profile_locked">
      <img class="pr-2" src="assets/img/locked.webp">{{mls.languageText.profile.key1}}
    </div>
  </div>

  <div class="profile_content w-100 bg-white p-3 mb-3">
    <img class="pr-2" src="assets/img/experience.webp"> {{mls.languageText.profile.key4}}
    <div class="float-right profile_locked">
      <img class="pr-2" src="assets/img/locked.webp">{{mls.languageText.profile.key1}}
    </div>
  </div>

  <div class="profile_content w-100 bg-white p-3 mb-3">
    <img class="pr-2" src="assets/img/certificate.webp"> {{mls.languageText.profile.key5}}
    <div class="float-right profile_locked">
      <img class="pr-2" src="assets/img/locked.webp">{{mls.languageText.profile.key1}}
    </div>
  </div>

  <div class="profile_content w-100 bg-white p-3 mb-3">
    <img class="pr-2" src="assets/img/publication.webp"> {{mls.languageText.profile.key6}}
    <div class="float-right profile_locked">
      <img class="pr-2" src="assets/img/locked.webp">{{mls.languageText.profile.key1}}
    </div>
  </div>

  <button type="button" class="btn btn-success w-100 p-3 mb-5" (click)="navigateto()">
    {{mls.languageText.profile.key7}}
  </button>
</div>

<div *ngIf="no_recfound" class="text-center">
  {{profileErrorMsg}}
</div>

<div *ngIf="is_res_received && no_recfound==false" class="bg-white p-3 mb-2 rounded cursor-pointer">
</div>